import { AUDIO_REFERRAL_SOURCES } from './constants'

export const hasSelectedAudioReferral = (selectedReferrals: string[]) =>
  selectedReferrals.some((selectedSource) =>
    AUDIO_REFERRAL_SOURCES.includes(selectedSource),
  )
